import styled from 'styled-components'

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-size: 24px;
  font-weight: bold;
`

export const Label = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-size: 16px;
`

export const AvatarContainer = styled.div`
  padding-right: 10px;
`

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
`

export const SubTitle = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.text};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding-bottom: 5px;
`

export const SectionTitle = styled(Title)`
  margin-top: 10px;
  margin-bottom: 10px;
`
